import ModalsForm from "./ModalsForm.vue";

export { ModalsForm };
